import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteLicense } from '@/lib/api';
import { licenseQueryKeys } from './useLicenseStatus';

export function useDeleteLicense() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: deleteLicense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: licenseQueryKeys.status() });
      queryClient.invalidateQueries({ queryKey: licenseQueryKeys.details() });
    },
  });
}
